import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../../i18n/constants/keys';

interface PreQualFooterProps {
  onBack: () => void;
  onNext: () => void;
}

export const PreQualFooter = ({ onBack, onNext }: PreQualFooterProps) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pt: 3,
        mt: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Button
        variant="text"
        color="inherit"
        onClick={onBack}
        startIcon={<ArrowBackRoundedIcon sx={{ fontSize: 18 }} />}
        sx={{
          color: 'text.secondary',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.85rem',
          '&:hover': {
            color: 'text.primary',
            bgcolor: 'action.hover',
          },
        }}
      >
        {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.backToVideo)}
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={onNext}
        endIcon={<ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />}
        sx={{
          px: 4,
          height: 42,
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: '0 4px 14px rgba(99, 102, 241, 0.25)',
        }}
      >
        {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.settings.next)}
      </Button>
    </Box>
  );
};
